import { BaseRepository } from "@/repositories/base-repository"
import { type IProject } from "@/interfaces/api/project.interface"

export class ProjectRepository extends BaseRepository<IProject> {
  protected resourcePath = "core/projects"
}
